import styled from 'styled-components'

export const Title = styled.div`
  color: #213f68;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  a {
    color: #0085ff;
    font-size: 14px;
    float: right;
    padding: 6px 8px;
    svg {
      margin-right: 6px;
    }
  }
`

export const Description = styled.div`
  font-size: 14px;
  padding: 8px 16px;
  color: #363636;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-bottom: 16px;
  svg {
    margin-right: 12px;
  }
`
